import { useState } from "react";
import styles from "../../styles/Videos/video.module.css";
import IndividualCategory from "./IndividualCategory";

export const Categories = [
  {
    id: 1,
    title: "Public Speaking Skills",
    description: "4+ lessons. 1+ hours",
    thumbnail:
      "https://i.ytimg.com/vi/saSuovTdS5E/hqdefault.jpg?sqp=-oaymwEnCNACELwBSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLAPybMGbcDs_ALYrvrKRbGpi-j2-w",
  },
  {
    id: 2,
    title: "Unleashing The Entrepreneurial Spirit",
    description: "2+ lessons. 1+ hours",
    thumbnail:
      "https://i.ytimg.com/vi/7o-VYbCiBCI/hq720.jpg?sqp=-oaymwEnCNAFEJQDSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLD6S3_QMzXflP5vf4UABTqX2k3M5A",
  },
  {
    id: 3,
    title: "The Art Of Copywriting",
    description: "2+ lessons. 1+ hours",
    thumbnail:
      "https://i.ytimg.com/vi/CwfXs4XuYvI/hq720.jpg?sqp=-oaymwEnCNAFEJQDSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLBf5nAYBC7mqxuvS6RIoeYGAN4BLQ",
  },
  {
    id: 4,
    title: "Effective Reading",
    description: "2+ lessons. 1+ hours",
    thumbnail: "https://i.ytimg.com/vi_webp/1GYiA550Iqg/maxresdefault.webp",
  },
  {
    id: 5,
    title: "Mindmaps Power",
    description: "4+ lessons. 1+ hours",
    thumbnail: "https://i.ytimg.com/vi_webp/1_eOArOBwiM/maxresdefault.webp",
  },
  {
    id: 6,
    title: "Productivity Tips and Hacks",
    description: "18+ lessons. 3+ hours",
    thumbnail: "https://i.ytimg.com/vi/JUZ2XY1d4Bc/maxresdefault.jpg",
  },
  {
    id: 7,
    title: "Presentation Skills",
    description: "2+ lessons. 1+ hours",
    thumbnail: "https://i.ytimg.com/vi/DFeWLCt91sI/maxresdefault.jpg",
  },
  {
    id: 8,
    title: "Become A Star Entrepreneur",
    description: "10+ lessons. 2.5+ hours",
    thumbnail: "https://i.ytimg.com/vi/Y2q076z7ZUs/maxresdefault.jpg",
  },
  {
    id: 9,
    title: "How To Become A Creative Thinker",
    description: "17+ lessons. 3+ hours",
    thumbnail: "https://i.ytimg.com/vi/KjDzpfS6y3w/maxresdefault.jpg",
  },
  {
    id: 10,
    title: "Attitude Is Everything",
    description: "8+ lessons. 1+ hours",
    thumbnail: "https://i.ytimg.com/vi_webp/CSxnnzwssFo/maxresdefault.webp",
  },
  {
    id: 11,
    title: "Effective Time Management",
    description: "2+ lessons. 1+ hours",
    thumbnail: "https://i.ytimg.com/vi_webp/eY4W3AQ3K7M/maxresdefault.webp",
  },
];

const VideoCategories = ({ clickedPlaylist }) => {
  const [category, setCategory] = useState("");

  // Filter categories based on search input
  const filteredCategories = Categories.filter((cat) =>
    cat.title.toLowerCase().includes(category.toLowerCase())
  );

  return (
    <div id={styles.videoCategoriesContainer} style={{ flexShrink: "0" }}>
      <div style={{ position: "relative" }}>
        {category === "" && ( // Hide icon when there's input
          <span
            style={{
              position: "absolute",
              top: "50%",
              left: "15px",
              transform: "translateY(-50%)",
            }}
          >
            <img src="/search.svg" alt="search-icon" />
          </span>
        )}
        <input
          type="text"
          className={styles.input}
          value={category}
          placeholder="Search course"
          onChange={(e) => setCategory(e.target.value)}
        />
      </div>
      <div id={styles.categoryContainer}>
        <div id={styles.categoryListContainer}>
          <div style={{ color: "#b090a7", fontWeight: "bold" }}>Categories</div>
          <div>
            <div>
              {filteredCategories.length > 0 ? (
                filteredCategories.map((cat, index) => (
                  <IndividualCategory
                    key={index}
                    title={cat.title}
                    description={cat.description}
                    thumbnail={cat.thumbnail}
                    click={() => clickedPlaylist(cat)}
                  />
                ))
              ) : (
                <div className={styles.noCategories}>No categories found</div>
              )}
            </div>
            {/* <div className={styles.singleCategoryContainer}>
              <div className={styles.categoryImageContainer}></div>
              <div className={styles.categoryDescContainer}>
                <div className={styles.categoryTitle}>Sales And Marketing</div>
                <div className={styles.categoryDesc}>40+ lessons. 4+ hours</div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoCategories;
